import { Pipe, PipeTransform } from '@angular/core';
import { TDate } from '@monorepo/types';
import * as moment from 'moment';

@Pipe({
  name: 'dateTimeFormat',
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(value: TDate | string) {
    console.log('Pipe Strip', value);
    return moment(value).format('LT ll');
  }
}
